import React, { Component } from 'react';
import classnames from 'classnames';

import TickerFrame from '../../TickerFrame/TickerFrame';

class HomepageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false
    }

    this.elRef = React.createRef();
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.el = this.elRef.current;
    this.update();
  }

  update() {
    const distanceFromTop = this.el.getBoundingClientRect().top + (this.el.offsetHeight / 2);
    const distanceFromCenter = Math.abs((window.innerHeight / 2) - distanceFromTop);
    const isActive = distanceFromCenter < 200 && window.innerWidth < 768;

    // If there's an activate class and the active state changes; run it!
    if (isActive !== this.state.hover) {
      if (isActive && this.props.onActivated) {
        this.props.onActivated();
      } else if (this.props.onDeactivated) {
        this.props.onDeactivated();
      }
    }

    this.setState({
      hover: isActive
    });

    this.raf = window.requestAnimationFrame(this.update);
  }

  render() {
    const elClass = classnames(this.props.className, {
      [this.props.hoverClass]: this.state.hover
    });

    return (
      <a className={elClass} ref={this.elRef} href={this.props.href} target={this.props.target} onMouseEnter={this.props.onActivated} onMouseLeave={this.props.onDeactivated}>
        { this.props.children }
        <TickerFrame />
      </a>
    );
  }
}

export default HomepageComponent;